import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Contact } from '../../interfaces/Contact';
import PhoneRow from '../PhoneRow';

export interface PhonesProps {
  contact: Contact;
}

const Phones: FC<PhonesProps> = ({ contact }) => {
  const { t } = useTranslation('ContactUsPage');

  return (
    contact && contact.phones ?
      <PhoneRow
        title={t('telephone')}
        numbers={contact.phones}
        callable
      />
      : null
  );
};

export default Phones;
